import React from "react";
import TargetAcheivedStars from "../../components/TargetAcheivedStars";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import ReportsExecutiveSummary from "../ReportsExecutiveSummary";
import ReportsCriteriaDetails from "../ReportsCriteriaDetails";
import ReportsAppendix from "../ReportsAppendix";
import A4Page from "../../components/A4Page";
import { useSelector } from "react-redux";
import { draftData } from "../ReportEditor/staticReportData";
import ReportsSectionSeperator from "../../components/ReportsSectionSeperator";

const ReportGenerator = () => {
    const [t] = useTranslation();
    const reportData = useSelector((state:any) => state.evaluation.reportData);
    // const reportData = draftData;
    return (
        <Box id={'pdf-content'}>
          <ReportsExecutiveSummary />
          <ReportsSectionSeperator />
            {
                reportData?.Criteria &&
                reportData?.Criteria
                  .map((item:any) => {
                    return (
                      <>
                        <ReportsCriteriaDetails data={item} reportType={reportData?.ReportType} />
                        <ReportsSectionSeperator />
                      </>
                    )
                })
            }
          <ReportsAppendix />
        </Box>
    )
}

export default ReportGenerator;